<template>
  <div class="addressManagement">
        <el-dialog
        :title="$t('other.a1973')"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :modal='false'
        width="30%"
        >
        <div class="itemlist">
            <span class="tipn">*</span>{{$t('other.a1015')}}<el-input style="" size="medium" v-model="addressParams.receiver" :placeholder="$t('other.a1974')"></el-input>
        </div>
        <div class="itemlist">
            <span class="tipn">*</span>{{$t('other.a1978')}}<el-input size="medium" v-model="addressParams.phone" :placeholder="$t('other.a1975')"></el-input>
        </div>
        <div class="itemlist">
            <span class="tipn">*</span>{{$t('other.a517')}}<el-input size="medium" type="textarea" :autosize="{ minRows: 4, maxRows: 8}" v-model="addressParams.address" :placeholder="$t('other.a1976')"></el-input>
        </div>
        <div class="itemlist">
            <span class="tipn">*</span>{{$t('other.a626')}}<el-input size="medium"  v-model="addressParams.postcode" :placeholder="$t('other.a1977')"></el-input>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">{{$t('other.a106')}}</el-button>
            <el-button type="primary" @click="addNewList()">{{$t('other.a279')}}</el-button>
        </span>
      </el-dialog>
      <div>{{$t('other.a1014')}}</div>
      <div class="addNew">
          <el-button type="primary" @click="dialogVisible=true">{{$t('other.a1973')}}</el-button>
      </div>

      <div>
          <el-table
          :data="list"
          :key="itemKey"
          border
          style="width: 100%">
          <el-table-column
          :label="$t('other.a518')"
          prop="userId">
           <template slot-scope="props">
				   {{props.row.receiver}}
		   </template>
          </el-table-column>
          <el-table-column
          :label="$t('other.a899')"
          prop="userId">
           <template slot-scope="props">
				   {{props.row.phone}}
		   </template>
          </el-table-column>
          <el-table-column
          :label="$t('other.a517')"
          prop="userId">
           <template slot-scope="props">
				   {{props.row.phone}}
		   </template>
          </el-table-column>
          <el-table-column
          :label="$t('other.a626')"
          prop="userId">
           <template slot-scope="props">
				{{props.row.phone}}
		   </template>
          </el-table-column>
          <el-table-column
          :label="$t('other.a626')"
          prop="userId">
           <template slot-scope="props">
               <div>
				<span :class="{'ioingn':!props.row.defaultFrom,'pking':props.row.defaultFrom}" @click="setDefult(props.row,props.$index,0)">{{$t('other.a1029')}}</span>
                <span class="ioingn" @click="setDefult(props.row,props.$index)">{{$t('other.a93')}}</span>
               </div>
               <div>
                <span :class="{'ioingn':!props.row.defaultReceive,'oegvjh':props.row.defaultReceive}" @click="setDefult(props.row,props.$index)">{{$t('other.a1030')}}</span>
                <span class="ioingn" @click="deleteItem(props.row,props.$index)">{{$t('other.a312')}}</span>
               </div>
		   </template>
          </el-table-column>
       
          
      </el-table> 
      </div>
  </div>
</template>

<script>
import utils from '../../utils/utils'
export default {
data(){
return{
    dialogVisible:false,
    itemKey:0,
    userId:JSON.parse(localStorage.getItem('userInfo')).userId,
    addressParams:{
        address:null,
        postcode:null,
        receiver:null,
        phone:null,
        defaultReceive:false,
        defaultFrom:false,
        checked:false,
    },
    list:[],
}
},
watch:{
    dialogVisible(){
        this.addressParams={
            address:null,
            postcode:null,
            receiver:null,
            phone:null,
            defaultReceive:false,
            defaultFrom:false,
            checked:false,
        }
    },
},
created(){
    this.getData()
},
methods:{

    getData(){
        utils.getInfoByCache({
            userId:this.userId,
            cacheKey:'userAddress'
        }).then(res => {
            this.list=res
            console.log('res',this.list)
        })

        
    },

    addNewList(){
        console.log('addressParams',this.addressParams)
        if(!this.addressParams.receiver){
            this.$message.warning(this.$t('other.a1979'))
        }else if(!this.addressParams.phone){
            this.$message.warning(this.$t('other.a1980'))
        }else if(!this.addressParams.address){
            this.$message.warning(this.$t('other.a1981'))
        }
        this.list.push(this.addressParams)

        this.updata()
        this.$message.success(this.$t('other.a1982'))
        this.dialogVisible=false
    },
    setDefult(item,index,num){
        if(num == 0){
            this.list.forEach(p => {
                p.defaultFrom=false
            })
            item.defaultFrom=!item.defaultFrom
            console.log(item)
        }else{
            this.list.forEach(p => {
                p.defaultReceive=false
            })
            item.defaultReceive=!item.defaultReceive
        }
        this.updata()
       
        this.itemKey++
    },
    deleteItem(item,index){
        this.list.splice(index,1)
         this.updata()
    },

    updata(){
         utils.updateInfoByCache({
            cacheKey:'userAddress',
            userId:this.userId,
            cacheData:JSON.stringify(this.list)
        })
    },

}
}

</script>
<style lang="scss" scoped>

.addressManagement{
    margin-bottom: 120px;
    /deep/ .v-modal{
        background-color: none;
    }
    .addNew{
        margin: 20px 0;
    }

    .itemlist{
        margin-bottom: 10px;
    }

    .tipn{
        color: red;
        display: inline-block;
        margin: 10px 0;
    }

    .ioingn{
        display: inline-block;
        margin: 0 10px 10px 10px;
        cursor: pointer;
    }

    .pking{
        color: red;
        display: inline-block;
        margin: 0 10px 10px 10px;
        cursor: pointer;
    }

    .oegvjh{
        color: #409EFF;
        display: inline-block;
        margin: 0 10px 10px 10px;
        cursor: pointer;
    }



   
}

</style>